<template>
    <v-row>
        <v-col cols="12" class="text-h6 kbDarkBlue--text">
            <h3 class="pt-5">{{ from === 'Place' ? $t('general.placeContacts') : $t('general.eventContacts') }}</h3>
        </v-col>

        <v-col cols="12" v-for="(contact, index) in value" :key="contact.key">
            <v-card>
                <v-card-text>
                    <v-row class="pa-1"   >
                        <v-col cols="12" sm="6">
                            <v-text-field :label="$t('general.title')"
                                          color="kbDarkBlue"
                                          v-model="contact.title"
                                          prepend-icon="mdi-star"
                                          :readonly="readonly"/>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field :label="$t('general.name')"
                                          color="kbDarkBlue"
                                          v-model="contact.name"
                                          prepend-icon="mdi-account"
                                          :readonly="readonly"/>
                        </v-col>

                        <v-col cols="12" sm="6">
                          <CountryPhonePicker
                            v-model="contact.phone"
                            :readonly="readonly"
                          />
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field label="Email"
                                          color="kbDarkBlue"
                                          v-model="contact.email"
                                          prepend-icon="email"
                                          :rules="[rules.email]"
                                          :readonly="readonly">
                            </v-text-field>
                        </v-col>

                        <v-col class="text-right" cols="12" >
                            <v-btn v-if="!readonly" color="error" rounded @click="deleteItem(index)">{{ $t('general.deleteContact') }}</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>

        <v-col cols="12">
            <v-btn v-if="!readonly" color="kbGold" dark @click="addItem()" rounded>{{ $t('general.addContact') }}</v-btn>
        </v-col>
    </v-row>
</template>

<script>
import { mapState } from 'vuex'
import uniqid from 'uniqid'
import rules from '@/libs/rules'
import CountryPhonePicker from '@/components/ui/CountryPhonePicker'
export default {
  components: {
    CountryPhonePicker
  },
  computed: {
    ...mapState({
    })
  },

  created () {
    if (this.value.length === 0) {
      this.addItem()
    }
  },
  data () {
    return {
      item: {
        title: '',
        name: '',
        phone: {},
        email: '',
        key: ''
      },
      rules
    }
  },
  methods: {
    addItem () {
      this.item.key = uniqid()
      this.value.push(JSON.parse(JSON.stringify(this.item)))
    },
    deleteItem (index) {
      this.value.splice(index, 1)
    }
  },
  props: ['value', 'from', 'readonly']
}
</script>
